// Échelles de la carte territoriale pour les écrans des marchés et du domaine public : mêmes
// limites (OpenStreetMap, tracés indicatifs) et même construction que l'écran Territoire ; les
// couches GeoJSON de l'API sont demandées pour l'emprise de l'échelle affichée (bbox).
import type { FeatureCollection, MultiPolygon, Polygon } from 'geojson';
import { useEffect, useMemo, useState } from 'react';
import { construireEchelles, fichierPourEchelle, fichiersInitiaux, useLimites, useTerritoire, type NomFichier } from '../territoire/donnees';
import { bboxEchelle } from './logique';
import type { CarteDomainePublic } from './types';

export function useEchellesTerritoire() {
  const territoire = useTerritoire();
  const [supplementaires, setSupplementaires] = useState<NomFichier[]>([]);
  const fichiers = useMemo(() => [...new Set([...fichiersInitiaux(territoire.data), ...supplementaires])], [territoire.data, supplementaires]);
  const { limites, presentation, chargement, erreur } = useLimites(fichiers, fichiersInitiaux(territoire.data));
  const [echelle, setEchelleBrute] = useState<string | null>(null);
  const echelles = useMemo(() => (territoire.data && !chargement ? construireEchelles(territoire.data, limites, presentation) : null), [territoire.data, chargement, limites, presentation]);
  useEffect(() => {
    if (echelles && !echelle) setEchelleBrute(echelles.defaut);
  }, [echelles, echelle]);
  const setEchelle = (id: string) => {
    const f = fichierPourEchelle(id);
    if (f) setSupplementaires((s) => (s.includes(f) ? s : [...s, f]));
    setEchelleBrute(id);
  };
  const courante = echelles?.echelles.find((e) => e.id === echelle);
  return {
    territoire,
    echelles,
    echelle,
    setEchelle,
    courante,
    /** Emprise de l'échelle affichée (bbox des routes GeoJSON) ; null tant qu'aucune limite n'est connue. */
    bbox: bboxEchelle(courante),
    erreurLimites: erreur,
    pret: Boolean(echelles && echelle),
  };
}

/** Surfaces à dessiner : les emprises saisies (polygones) de la couche des autorisations. */
export function surfacesAutorisations(c: CarteDomainePublic | undefined): FeatureCollection<Polygon | MultiPolygon> {
  return {
    type: 'FeatureCollection',
    features: (c?.features ?? [])
      .filter((f) => f.geometry.type === 'Polygon')
      .map((f) => ({ type: 'Feature' as const, id: f.id, geometry: f.geometry as Polygon, properties: { numero: f.properties.numero } })),
  };
}
